import React from 'react';
import classNames from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';
import {
  Image,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const BlockCta = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const reversed = entity.getIn(['field_flipped', 0, 'value'], false);
  const body = entity.getIn(['field_body', 0, 'processed'], '');
  const image = entity.getIn(['field_media_item', 0, 'styles', 'teaser_square'], '');
  const alt = entity.getIn(['field_media_item', 0, 'alt'], '');
  const linkTitle = entity.getIn(['field_link', 0, 'title'], null);
  const linkHref = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  const classes = classNames('BlockCta', [
    reversed ? 'reversed' : null,
    linkHref ? 'hasLink' : null,
  ]);

  return (
    <div className={classes}>
      {linkHref && (
        <CoreLink to={linkHref} className="overlapping-link" />
      )}
      <div className="BlockCta__content">
        <div className="BlockCta__contentWrapper order-2 order-md-1">
          <h2 className="BlockCta__title">{title}</h2>
          <WysiwygField
            property="schema:text"
            className="BlockCta__body"
            html={body}
          />

          {linkTitle && (
            <Button>
              {linkTitle}
            </Button>
          )}
        </div>
        {entity.getIn(['field_media_item', 0, 'styles', 'teaser_square']) ? (
          <div className="BlockCta__imageWrapper order-1 order-md-2">
            <Image
              alt={alt}
              lazyload={false}
              className="BlockCta__image"
              src={image}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default BlockCta;
